<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import axios from "axios";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  created() {
    this.httpCallReportData()
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Default",
          active: true
        }
      ],
      transactions: [],
      monthlyRegisteredUserChartData: {
        series: [
          {
            name: "Kiddy",
            data: [44, 55, 41, 67, 22, 43, 36, 52, 24, 18, 36, 48]
          },
          {
            name: "Junior",
            data: [13, 23, 20, 8, 13, 27, 18, 22, 10, 16, 24, 22]
          },
          {
            name: "Upper",
            data: [11, 17, 15, 15, 21, 14, 11, 18, 17, 12, 20, 18]
          },
          {
            name: "Senior",
            data: [11, 17, 15, 15, 21, 14, 11, 18, 17, 12, 20, 18]
          },
        ],
        chartOptions: {
          chart: {
            stacked: false,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: true
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "35%",
              endingShape: "rounded"
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ]
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val.toLocaleString()
              }
            }
          },
          colors: ["#556ee6", "#f1b44c", "#34c38f", "#ddd"],
          legend: {
            position: "bottom"
          },
          fill: {
            opacity: 1
          }
        }
      },
      userTypeChart: {
        series: [25, 25, 25, 25],
        chartOptions: {
          chart: {
            type: 'donut',
            height: 240,
          },
          labels: ['Kiddy', 'Junior', 'Upper', 'Senior'],
          colors: ['#556ee6', '#34c38f', '#f46a6a', '#ddd'],
          legend: {
            show: false,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '70%',
              }
            }
          }
        }
      },
      userPaymentStatusChart: {
        series: [33.3, 33.3],
        chartOptions: {
          chart: {
            type: 'donut',
            height: 240,
          },
          labels: ['Paid', 'Not Paid'],
          colors: ['#556ee6', '#34c38f'],
          legend: {
            show: false,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '70%',
              }
            }
          }
        }
      },
      salesChartDataKey: 0,
      userPaymentStatus: {
        paid: 0,
        not_paid: 0,
      },
      userType: {
        kiddy: 0,
        junior: 0,
        upper: 0,
        senior: 0,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      getArguments: {
        limit: 10,
        page: 1,
        sort: '-id',
        name: '',
        fully_paid: true,
        for_dashboard: true,
        month: ''
      },
      exportLoading: false,
      viewType: 'all',
      selectedMonth: null,
      optionsMonth: [
        { value: null, text: 'Pilih Bulan' },
        { value: 1, text: 'Januari' },
        { value: 2, text: 'Februari' },
        { value: 3, text: 'Maret' },
        { value: 4, text: 'April' },
        { value: 5, text: 'Mei' },
        { value: 6, text: 'Juni' },
        { value: 7, text: 'Juli' },
        { value: 8, text: 'Agustus' },
        { value: 9, text: 'September' },
        { value: 10, text: 'Oktober' },
        { value: 11, text: 'November' },
        { value: 12, text: 'Desember' },
      ],
      price: {}
    };
  },
  filters: {
    formatCurrency(number) {
      return number.toLocaleString() + ',-'
    }
  },
  methods: {
    httpCallReportData() {
      let url = "/api/account/report"
      axios.get(url)
          .then(resp => {
            const { data } = resp.data
            const monthlyRegisteredUser = data.monthly_registered_user
            const series = monthlyRegisteredUser.map(x => Object.keys(x)).flat()
            const seriesData = monthlyRegisteredUser.map(x => {
              return x[Object.keys(x)[0]]
            })
            const kiddyData = seriesData.map(x => x.kiddy)
            const juniorData = seriesData.map(x => x.junior)
            const upperData = seriesData.map(x => x.upper)
            const seniorData = seriesData.map(x => x.senior)
            this.monthlyRegisteredUserChartData.chartOptions.xaxis.categories = series
            this.monthlyRegisteredUserChartData.series[0].data = kiddyData
            this.monthlyRegisteredUserChartData.series[1].data = juniorData
            this.monthlyRegisteredUserChartData.series[2].data = upperData
            this.monthlyRegisteredUserChartData.series[3].data = seniorData
            this.forceRenderSalesChart()

            // user payment status chart
            const userPayments = data.user_payments
            this.userPaymentStatus.paid = userPayments.paid
            this.userPaymentStatus.not_paid = userPayments.not_paid
            const totalDataUserPayments = userPayments.paid + userPayments.not_paid
            const paidPercentage = Number((userPayments.paid/totalDataUserPayments*100).toFixed(2))
            const notPaidPercentage = Number((userPayments.not_paid/totalDataUserPayments*100).toFixed(2))
            this.userPaymentStatusChart.series = [paidPercentage, notPaidPercentage]

            // user type status chart
            const userType = data.registered_user_type
            this.userType.kiddy = userType.kiddy
            this.userType.junior = userType.junior
            this.userType.upper = userType.upper
            this.userType.senior = userType.senior
            const totalDataUserType = userType.kiddy + userType.junior + userType.upper + userType.senior
            const kiddyPercentage = Number((userType.kiddy/totalDataUserType*100).toFixed(2))
            const juniorPercentage = Number((userType.junior/totalDataUserType*100).toFixed(2))
            const upperPercentage = Number((userType.upper/totalDataUserType*100).toFixed(2))
            const seniorPercentage = Number((userType.senior/totalDataUserType*100).toFixed(2))
            this.userTypeChart.series = [kiddyPercentage, juniorPercentage, upperPercentage, seniorPercentage]
          });
    },
    forceRenderSalesChart() {
      this.salesChartDataKey += 1
    },
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getArguments.page = newValue
        let params = queryString.stringify(this.getArguments)
        this.httpCallOrderData(params)
      }
    },
  },
};
</script>

<style>
.row-eq-height {
  overflow: hidden;
}

.row-eq-height{
  margin-bottom: -99999px;
  padding-bottom: 99999px;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row row-eq-height">
      <div class="col-xl-6" style="height: 100%">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">User Payment Status</h4>

            <div>
              <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="240"
                  :series="userPaymentStatusChart.series"
                  :options="userPaymentStatusChart.chartOptions"
              ></apexchart>
            </div>
          </div>
          <div class="card-body" style="padding-bottom: 40px">
            <div class="text-center text-muted">
              <div class="row">
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-primary mr-1"></i>
                      Paid
                    </p>
                    <h5>{{ userPaymentStatus.paid }}</h5>
                  </div>
                </div>
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-success mr-1"></i>
                      Pending
                    </p>
                    <h5>{{ userPaymentStatus.not_paid }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6" style="height: 100%">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Registered User Type</h4>

            <div>
              <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="240"
                  :series="userTypeChart.series"
                  :options="userTypeChart.chartOptions"
              ></apexchart>
            </div>
          </div>
          <div class="card-body" style="padding-bottom: 40px">
            <div class="text-center text-muted">
              <div class="row">
                <div class="col-3">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-primary mr-1"></i>
                      Kiddy
                    </p>
                    <h5>{{ userType.kiddy }}</h5>
                  </div>
                </div>
                <div class="col-3">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-success mr-1"></i>
                      Junior
                    </p>
                    <h5>{{ userType.junior }}</h5>
                  </div>
                </div>
                <div class="col-3">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-danger mr-1"></i>
                      Upper
                    </p>
                    <h5>{{ userType.upper }}</h5>
                  </div>
                </div>
                <div class="col-3">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-danger mr-1"></i>
                      Senior
                    </p>
                    <h5>{{ userType.senior }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row row-eq-height">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Monthly Registered Users</h4>

            <apexchart
                class="apex-charts"
                type="bar"
                dir="ltr"
                height="362"
                :series="monthlyRegisteredUserChartData.series"
                :options="monthlyRegisteredUserChartData.chartOptions"
                :key="salesChartDataKey"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
